export const apiroot = "app/api/";//"http://ruchepabp1c01:5001/api/";//"app/api/";//"https://localhost:44367/api/";//"http://ruchetabpzzz01:5001/app/api/";//"https://localhost:44366/api/";//"app/api/";//  //"http://localhost:41890/api/";  "https://localhost:44363/api/";

export const handleResponse = (response) => {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
};

export const requestBase = (() => {
    //if (typeof window !== "undefined") {
    return {
        method: "POST",
        credentials: "include",
        mode: 'cors',

        //withCredentials: true,

        //headers: new Headers({
        //    Accept: "application/json",
        //    "Content-Type": "application/json",
        //}),
    };
    //} else
    //    return {
    //        method: "POST",
    //        credentials: "include",
    //        // mode: 'cors',
    //        //headers: {
    //        //    Accept: "application/json",
    //        //    "Content-Type": "application/json",
    //        //},
    //    };
})();
